<template>
  <component
    :is="componentType"
    :type="!link ? type : false"
    :to="redirectionLink"
    class="button button-full"
    :class="{ 'disabled': disabled }"
    data-testid="subscribeSubmit"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot>
      Button
    </slot>
  </component>
</template>
<script>
import ButtonPrimary from './ButtonPrimary'

export default {
  name: 'ButtonFull',
  mixins: [ ButtonPrimary ]
}
</script>

<style lang="scss" scoped>
.button-full {
  width: 100%;
}
</style>
